import { Injectable } from '@angular/core';
import { db } from '../db';
import { SynchronizationCheckpoint } from '../models/synchronization-checkpoint';
import { BaseRepository } from './base.repository';

@Injectable({
  providedIn: 'root',
})
export class SynchronizationCheckpointRepository extends BaseRepository<
  SynchronizationCheckpoint,
  string
> {
  constructor() {
    super(db.synchronizationCheckpoints, 'userEmail');
  }

  async getByUserEmail(userEmail: string): Promise<SynchronizationCheckpoint | undefined> {
    return await this.getById(userEmail);
  }

  async save(checkpoint: SynchronizationCheckpoint): Promise<string> {
    await this.table.put(checkpoint);
    return checkpoint.userEmail;
  }
}
